import * as React from "react";
import { Event, Page, ThemeKind } from "src/types";

import {
  logProductAnalyticsEvent,
  PAGE_BUILDER_EVENTS,
} from "@/features/analytics";

import useEvent from "./use-event";
import usePage from "./use-page";

interface InitialData {
  page: Page;
  event: Event;
}

export default function useAnalytics(initialData?: Partial<InitialData>) {
  const { event = initialData?.event } = useEvent() || {};
  const { page = initialData?.page } = usePage() || {};

  const logAnalytics = React.useCallback(
    (
      eventKey: keyof typeof PAGE_BUILDER_EVENTS,
      nextProps?: Record<string, any>
    ) => {
      const eventName = PAGE_BUILDER_EVENTS[eventKey];

      logProductAnalyticsEvent({
        name: eventName,
        properties: {
          organisation_id: event.organization.external_id,
          organisation_name: event.organization.name,
          event_id: event.external_id,
          event_name: event.name,
          event_published: event.status === "live",
          start_time: event.time_start,
          end_time: event.time_end,
          registration_theme: page.properties?.theme?.kind || ThemeKind.CROSBY,
          ...nextProps,
        },
      });
    },
    [event, page]
  );

  return {
    logAnalytics,
  };
}
